/**
 * Selection for a step that takes exactly one product.
 *
 * Picking a product replaces whatever was picked before, and re-clicking the selected one keeps
 * it selected: a management recommendation has no meaning without a product, so there is no
 * deselected state to fall back to — clearing it would only leave the Next button dead.
 */
export const selectSingleProduct = (selectedIds: number[], id: number): number[] => {
    if (selectedIds.length === 1 && selectedIds[0] === id) return selectedIds;
    return [id];
};
